export default class Search {
    static init() {
        this.btnSearchOpen = document.querySelector(".search-box-open");
        this.btnSearch = document.querySelector(".search-box .btn-search");
        if (!this.btnSearchOpen || !this.btnSearch) {
            return;
        }
        this.initSearch();
    }

    static initSearch() {
        this.btnSearchOpen.addEventListener('click', (e) => {
            e.preventDefault();
            this.openSearch();
        });

        this.btnSearch.addEventListener('click', (e) => {
            e.preventDefault();
            let lang = this.btnSearch.dataset.lang;
            this.performSearch(lang);
        });

        document.querySelector(".search-box .btn-close").addEventListener('click', (e) => {
            e.preventDefault();
            this.closeSearch();
        });
    }

    static openSearch() {
        document.body.classList.add('search-opened');
        document.querySelector(".search-box input[type='search']").focus();
    }

    static closeSearch() {
        document.body.classList.remove('search-opened');
    }

    static performSearch(lang) {
        const searchInput = document.querySelector(".search-box input[type='search']");
        const searchQuery = searchInput.value;
        if (searchQuery) {
            if (lang == "fr") {
                window.location.href = `/?s=${searchQuery}`;
            } else {
                window.location.href = `/${lang}/?s=${searchQuery}`;
            }
        }
    }
}